


































import { computed, defineComponent, toRef } from "@vue/composition-api";
import {
  CreatorService,
  CreatorServiceMessageDetails,
  isCreatorServiceMessageDetails,
} from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import useMessageView from "@/hooks/useMessageView";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { formatMoneyString } from "@/lib/moneyHelpers";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";
import CreatorServiceTag from "@/features/CreatorService/components/CreatorServiceTag.vue";
import { CreatorServiceCategoryNamesMap } from "@/features/CreatorService/const";
import { resolveCreatorTagsByIds } from "@/features/CreatorService/helpers";

export default defineComponent({
  name: "SystemMessageServicePurchase",
  inheritAttrs: false,
  components: { CreatorServiceTag, FormatMoney, BaseIcon },
  props: {
    message: { type: Object as () => Message, required: true },
    markAsSeen: { type: Boolean, required: true },
    authUserId: { type: String, required: true },
  },
  setup(props) {
    const { isOpponentMessage, hoursMinutes, fullTime } = useMessageView(toRef(props, "message"), props.authUserId);
    const details = computed<CreatorServiceMessageDetails | null>(() =>
      isCreatorServiceMessageDetails(props.message.details) ? props.message.details : null
    );

    const item = computed<CreatorService | null>(() =>
      details.value?.creatorService ? details.value.creatorService : null
    );

    const previewSrc = computed(() =>
      item.value?.preview ? MediaFilesController.getImageThumbnail(item.value.preview.urlPart, 100) : null
    );

    const categoryLabel = computed(() => {
      if (!item.value) return "";
      return CreatorServiceCategoryNamesMap[item.value.category] || item.value.category;
    });

    const resolvedTags = computed(() => resolveCreatorTagsByIds(item.value?.tags || []));

    return {
      isOpponentMessage,
      hoursMinutes,
      fullTime,
      details,
      item,
      previewSrc,
      categoryLabel,
      resolvedTags,
      formatMoneyString,
    };
  },
});
